var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_240_23056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1213 5.12135C5.31656 4.92608 5.63314 4.92608 5.82841 5.12135L10.7782 10.0711C10.9734 10.2664 10.9734 10.5829 10.7782 10.7782C10.5829 10.9735 10.2663 10.9735 10.071 10.7782L5.1213 5.82845C4.92604 5.63319 4.92604 5.31661 5.1213 5.12135Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7782 5.12133C10.9734 5.31659 10.9734 5.63318 10.7782 5.82844L5.82841 10.7782C5.63315 10.9734 5.31657 10.9734 5.12131 10.7782C4.92604 10.5829 4.92604 10.2663 5.12131 10.0711L10.0711 5.12133C10.2663 4.92607 10.5829 4.92607 10.7782 5.12133Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_240_23056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.f4f7d869e0aa760db4519587751cda11.svg";
export { ForwardRef as ReactComponent };